// neurotrader-admin/src/components/StatCard.js
import React from 'react';
// Importaremos o CSS modificado a seguir
import './StatCard.css';

const StatCard = ({ title, primaryValue, secondaryValue, icon, valueClassName = '' }) => {
    return (
        <div className="stat-card">
            {icon && <div className="stat-icon">{icon}</div>}
            <div className="stat-info">
                <span className="stat-title">{title}</span>
                <span className={`stat-value primary ${valueClassName}`}>
                    {primaryValue}
                </span>
                {secondaryValue && (
                    <span className="stat-value secondary">{secondaryValue}</span>
                )}
            </div>
        </div>
    );
};

export default StatCard;